import React from "react"
import {useTranslation} from "next-i18next"
import Typography from "../../reusable/Typography/Typography"
import Image from "next/image"

const DisplayContent = (): React.ReactElement => {
	const {t} = useTranslation("consultationPage")
	return (
		<>
			<Typography style={{marginBottom: "32px"}}
				className=""
				variant="heading28To36"
				semanticTag="h2">{t("display")}</Typography>
			<Typography className="mb-2"
				variant="bodyLg"
				semanticTag="p">{t("display-para-1")}</Typography>
			<ul className="pb-3">
				<Typography variant="bodyLg"
					semanticTag="li">{t("display-para-1-listItem-1")}</Typography>
				<Typography variant="bodyLg"
					semanticTag="li">{t("display-para-1-listItem-2")}</Typography>
				<Typography variant="bodyLg"
					semanticTag="li">{t("display-para-1-listItem-3")}</Typography>
				<Typography variant="bodyLg"
					semanticTag="li">{t("display-para-1-listItem-4")}</Typography>
				<Typography variant="bodyLg"
					semanticTag="li">{t("display-para-1-listItem-5")}</Typography>
				<Typography variant="bodyLg"
					semanticTag="li">{t("display-para-1-listItem-6")}</Typography>
				<Typography variant="bodyLg"
					semanticTag="li">{t("display-para-1-listItem-7")}</Typography>
			</ul>

			<Typography className="my-4"
				variant="heading20To28"
				semanticTag="h2">{t("display-heading-2")}</Typography>

			<Typography variant="bodyLg"
				semanticTag="p">{t("display-para-2-1")}</Typography>
			<Typography variant="bodyLg"
				semanticTag="p">{t("display-para-2-2")}</Typography>
			<Typography variant="bodyLg"
				semanticTag="p">{t("display-para-2-3")}</Typography>

			<div className="d-flex justify-content-center my-5">
				<Image src="/assets/images/consultation-page/display.jpg"
					height={214}
					width={800}
					objectFit="contain"/>
			</div>

			<Typography className="mb-4"
				variant="heading20To28"
				semanticTag="h2">{t("display-heading-4")}</Typography>

			<Typography variant="bodyLg"
				semanticTag="p">{t("display-para-4-1")}</Typography>

			<Typography variant="bodyLg"
				semanticTag="p">{t("display-para-4-2")}</Typography>
			<ul className="mb-3">
				<Typography variant="bodyLg"
					semanticTag="li">{t("display-para-4-2-listItem-1")}</Typography>
				<Typography variant="bodyLg"
					semanticTag="li">{t("display-para-4-2-listItem-2")}</Typography>
				<Typography variant="bodyLg"
					semanticTag="li">{t("display-para-4-2-listItem-3")}</Typography>
				<Typography variant="bodyLg"
					semanticTag="li">{t("display-para-4-2-listItem-4")}</Typography>
				<Typography variant="bodyLg"
					semanticTag="li">{t("display-para-4-2-listItem-5")}</Typography>
				<Typography variant="bodyLg"
					semanticTag="li">{t("display-para-4-2-listItem-6")}</Typography>
				<Typography variant="bodyLg"
					semanticTag="li">{t("display-para-4-2-listItem-7")}</Typography>
			</ul>
			<Typography variant="bodyLg"
				semanticTag="p">{t("display-para-4-3")}</Typography>
			<ul className="mb-4 pb-3">
				<Typography variant="bodyLg"
					semanticTag="li">{t("display-para-4-3-listItem-1")}</Typography>
				<Typography variant="bodyLg"
					semanticTag="li">{t("display-para-4-3-listItem-2")}</Typography>
				<Typography variant="bodyLg"
					semanticTag="li">{t("display-para-4-3-listItem-3")}</Typography>
				<Typography variant="bodyLg"
					semanticTag="li">{t("display-para-4-3-listItem-4")}</Typography>
				<Typography variant="bodyLg"
					semanticTag="li">{t("display-para-4-3-listItem-5")}</Typography>
			</ul>

			<Typography className="mb-4"
				variant="heading2"
				semanticTag="h2">{t("display-heading-5")}</Typography>
			<Typography className="mb-1"
				variant="bodyLg"
				semanticTag="p">{t("display-para-5")}</Typography>
		</>)
}

export default DisplayContent
